export const addPossessive = (str: string) => {
    if (!str) return '';
    
    // Remove any trailing period
    if (str.endsWith(".")) {
        str = str.slice(0, -1);
    }
    // Check if the string ends with "s" and add apostrophe
    if (str.endsWith("s")) return str + "'";
    // Otherwise, add "'s"
    return str + "'s";
}